import createGetFormAsyncErrors from '../selectors/getFormAsyncErrors';
import immutable from '../structure/immutable';

export default createGetFormAsyncErrors(immutable);


//////////////////
// WEBPACK FOOTER
// ./~/redux-form/es/immutable/getFormAsyncErrors.js
// module id = 1195
// module chunks = 0